import React, { Suspense, lazy, useEffect, useState } from "react";

const InteractiveDemoModal = lazy(() => import("./InteractiveDemoModal"));

const EVENT = "junago:open-demo";

// Ouvre la démo interactive officielle depuis n'importe où (sans navigation, scroll préservé)
export const openInteractiveDemo = () => {
  window.dispatchEvent(new CustomEvent(EVENT));
};

export default function InteractiveDemoHost() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener(EVENT, handler);
    return () => window.removeEventListener(EVENT, handler);
  }, []);

  if (!open) return null;
  return (
    <Suspense fallback={null}>
      <InteractiveDemoModal onClose={() => setOpen(false)} />
    </Suspense>
  );
}
